<template>
	<div>
		<v-card class="p-4 mb-6">
			<table class="responsive-table produse">
				<thead>
					<tr>
						<th class="center-align">Nr.</th>
						<th>Denumire produse</th>
						<th v-if="tip_lucrare == 'gard'" class="center-align">
							Pret / buc fara TVA - eur -
						</th>
						<th v-else class="center-align">Pret / buc fara TVA - lei -</th>
						<th class="center-align">Cantitate</th>
						<th class="center-align">UM</th>
						<th class="center-align">Marja %</th>
						<th class="center-align">Valoare fără TVA</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(produs, index) in alte_obj" :key="index">
						<!-- the position is the number; renumberProducts keeps the stored nr in step -->
						<td class="width5 center-align">{{ index + 1 }}</td>
						<!--
							Pick an accessory from the catalogue, or type anything else. Choosing a
							catalogue entry fills in the price, unit and image; free text leaves the
							line to be priced by hand, the way it always was.
						-->
						<td class="width40">
							<v-combobox :value="produs.denumire" :items="automationList"
								placeholder="Denumire produs sau accesoriu din catalog" dense outlined
								hide-details="auto" @input="selectProduct(index, $event)"></v-combobox>
						</td>
						<!--
							The value total follows on @input, not @change: Vuetify does not pass the
							native change event through, and emits its own only on blur or Enter - so
							a click on the number spinner would leave the total behind.
						-->
						<td class="width10">
							<v-text-field v-model="produs.pret" class="num-field" placeholder="0.00" dense outlined
								hide-details="auto" @input="totalP(index)"></v-text-field>
						</td>
						<td class="width10">
							<v-text-field v-model="produs.cantitate" class="num-field" type="number" step="1"
								placeholder="0" dense outlined hide-details="auto"
								@input="totalP(index)"></v-text-field>
						</td>
						<td class="width6">
							<v-select v-model="produs.um" :items="ums" placeholder="UM" dense outlined
								hide-details="auto"></v-select>
						</td>
						<td class="width75">
							<v-text-field v-model="produs.marja" class="num-field" type="number" step="0.1"
								placeholder="0" dense outlined hide-details="auto"
								@input="totalP(index)"></v-text-field>
						</td>
						<td class="width10">
							<v-text-field v-model="produs.pret_t" class="num-field" placeholder="0.00" dense outlined
								hide-details="auto" readonly></v-text-field>
						</td>
						<td class="width5 text-center">
							<v-btn icon small class="delete-produs" title="Sterge produsul"
								@click="deleteProductForm(index)">
								<v-icon>mdi-delete-outline</v-icon>
							</v-btn>
						</td>
					</tr>
				</tbody>
				<tbody>
					<tr>
						<td colspan="5"></td>
						<td class="center-align bold">Valoare totala</td>
						<td class="center-align bold">
							<span>{{ totalsP }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</v-card>
		<div class="flex flex-col lg:flex-row justify-between items-start gap-4">
			<v-btn color="blue-grey" class="white-text uppercase" @click="addNewProductForm">
				<v-icon left small>mdi-plus</v-icon>Adauga produs
			</v-btn>
			<div class="flex flex-row justify-end gap-4">
				<v-btn v-if="tip == 'oferta'" color="blue-grey" class="white-text uppercase" x-large
					:to="'/oferte-productie/single/' + id">Anuleaza</v-btn>
				<v-btn v-else-if="tip == 'lucrare'" color="blue-grey" class="white-text uppercase" x-large
					:to="'/lucrari-productie/single/' + id">Anuleaza</v-btn>
				<v-btn color="teal" class="white-text uppercase" x-large @click="saveMateriale()">Salveaza</v-btn>
			</div>
		</div>

		<!-- <pre>{{tip_lucrare}} {{id}}</pre> -->
		<!-- <pre>{{ alte_obj }}</pre> -->
	</div>
</template>

<script>
export default {
	name: "EditMateriale",
	data() {
		return {
			cost_fara_tvaA: "0.00",
			val_fara_tvaA: "0.00",
		};
	},
	props: ["alte_obj", "country", "tip_lucrare", "tip", "id"],
	computed: {
		ums() {
			return this.$store.getters.ums;
		},
		/**
		 * The accessories on offer in this offer's country, as the picker wants them.
		 *
		 * The catalogue holds one row per country, so the name shown here - and the name stored on
		 * the line - is already the client's language. Nothing downstream has to translate it.
		 */
		automationList() {
			return this.$store.getters["fenceAccessories/forCountry"](this.country)
				.map(accessory => ({
					value: accessory.code,
					text: accessory.name,
					price: accessory.price,
					um: accessory.unit,
					filename: accessory.image,
					name: accessory.name
				}));
		},
		totalsP: function () {
			let v = 0;
			let t = 0;
			this.alte_obj.forEach(function (produs) {
				v = v + Number(produs.pret_v);
				t = t + Number(produs.pret_t);
			});
			this.cost_fara_tvaA = v.toFixed(2);
			this.val_fara_tvaA = t.toFixed(2);
			return this.val_fara_tvaA;
		},
	},
	methods: {
		/**
		 * What the combobox gave us for a line: a catalogue entry, or a name typed by hand.
		 *
		 * Vuetify hands back the item object when one was picked from the list and a plain string
		 * when the agent typed something of their own - which is the whole point of a combobox here,
		 * since most accessories are in the catalogue but not all of them are.
		 */
		selectProduct(index, selection) {
			const product = this.alte_obj[index];

			if (!selection) {
				product.denumire = "";
				return;
			}

			if (typeof selection === "string") {
				this.renameProduct(product, selection);
				return;
			}

			// the catalogue row is already this country's, so the stored name needs no translating
			product.denumire = selection.name;
			// kept so the line can be traced back to the catalogue it came from
			product.cod = selection.value;
			product.cantitate = 1;
			product.um = selection.um || "buc";
			// the catalogue price is net and these lines are net, so it goes in as it stands
			product.pret = Number(Number(selection.price).toFixed(2));
			product.filename = selection.filename;
			this.totalP(index);
		},
		/**
		 * A name typed over a line. Price and quantity stay as they are - the agent may be adjusting
		 * only the wording - but a line renamed away from the catalogue product it was taken from is
		 * no longer that product, so it loses the code and the picture that belonged to it.
		 *
		 * Lines from before the catalogue carry a filename and no code; those keep their image.
		 */
		renameProduct(product, name) {
			const catalogued = product.cod
				&& this.automationList.find((item) => item.value == product.cod);

			if (catalogued && catalogued.name != name) {
				product.cod = "";
				product.filename = "";
			}

			product.denumire = name;
		},
		/**
		 * Put the stored numbers back in step with the rows.
		 *
		 * The column is no longer typed in, so the position is the number - but `nr` is what the
		 * offer screen and the PDF print, so it has to follow. Deleting the second of three lines
		 * would otherwise leave 1, 3 on the client's document.
		 */
		renumberProducts() {
			this.alte_obj.forEach((produs, index) => {
				produs.nr = String(index + 1);
			});
		},
		addNewProductForm() {
			let nr = this.alte_obj.length + 1;
			this.alte_obj.push({
				nr: "" + nr + "",
				denumire: "",
				// the catalogue product this line came from; empty on a line typed by hand
				cod: "",
				cantitate: "",
				um: "",
				pret: "",
				pret_v: "",
				marja: "",
				pret_t: "",
			});
		},
		deleteProductForm(index) {
			this.alte_obj.splice(index, 1);
			this.renumberProducts();
		},
		totalP(index) {
			let cantitate = Number(this.alte_obj[index].cantitate);
			let pret = Number(this.alte_obj[index].pret);
			let total = cantitate * pret;
			this.alte_obj[index].pret_v = total.toFixed(2);
			total = total + total * (Number(this.alte_obj[index].marja) / 100);
			this.alte_obj[index].pret_t = total.toFixed(2);
		},
		saveMateriale() {
			let newMateriale = {
				alte_obj:
					this.alte_obj.length > 0 ? JSON.stringify(this.alte_obj) : null,
				cost_fara_tvaA: this.cost_fara_tvaA,
				val_fara_tvaA: this.val_fara_tvaA,
				tip: this.tip,
				id: this.id,
			};
			this.$store.dispatch("saveMateriale", newMateriale);
		},
	},
	created: function () {
		// only this offer's country is needed, and the store keeps it once loaded
		this.$store.dispatch("fenceAccessories/fetchAccessoriesForCountry", this.country);
		// a line saved before this column was read-only can carry any number at all, and the screen
		// now shows its position instead - so bring the two together before anything is saved
		this.renumberProducts();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.delete-produs:hover .v-icon {
	color: #ef4444;
}

/* the number columns read as a column of figures, so they centre like the headers above them */
.num-field ::v-deep input {
	text-align: center;
}

.save {
	width: 100%;
	padding: 6px 30px;
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
}

.save p {
	margin-right: 40px;
}
</style>
